"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeBetween = exports.Duration = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const moment_1 = __importDefault(require("moment"));
const styles = core_1.makeStyles(() => core_1.createStyles({
    h5: {
        fontFamily: 'Roboto Mono',
    },
}));
function Duration(props) {
    const classes = styles();
    return (react_1.default.createElement(core_1.Box, { display: "flex", justifyContent: "space-between", alignItems: "center" },
        react_1.default.createElement(core_1.Typography, { variant: "subtitle1" }, "Duration"),
        react_1.default.createElement(core_1.Typography, { variant: "h5", classes: { h5: classes.h5 } },
            react_1.default.createElement(TimeBetween, Object.assign({}, props)))));
}
exports.Duration = Duration;
function TimeBetween({ startTime, endTime }) {
    const dur = moment_1.default.duration(moment_1.default(endTime).diff(moment_1.default(startTime)));
    const minutes = dur.asMinutes();
    const h = Math.floor(minutes / 60);
    const mod = Math.ceil(minutes % 60).toString();
    const m = mod.length === 1 ? '0' + mod : mod;
    const duration = minutes < 0 ? '-- : --' : h + ':' + m;
    return react_1.default.createElement(react_1.default.Fragment, null, startTime && endTime ? duration : '-- : --');
}
exports.TimeBetween = TimeBetween;
